import React from "react";

export default function PendingAttachmentList({ files = [], onRemove }) {
  if (!files.length) return null;

  return (
    <div className="mt-4 p-3 bg-light rounded border">
      <div className="text-muted mb-2">Files Ready To Save</div>
      <ul className="list-group">
        {files.map((attachment, index) => {
          const file = attachment.file;
          const key = `${file?.name || "file"}_${file?.size || 0}_${
            file?.lastModified || 0
          }_${index}`;

          return (
            <li
              key={key}
              className="list-group-item d-flex justify-content-between align-items-center gap-3"
            >
              <div className="text-break">
                <div className="fw-semibold">
                  {file?.name || attachment.name || "Unnamed file"}
                </div>
                <div className="text-muted small">
                  {attachment.type || "Unknown type"}
                </div>
              </div>
              <button
                type="button"
                className="btn btn-sm btn-outline-danger flex-shrink-0"
                data-delete-permission-exempt="true"
                onClick={() => onRemove(attachment)}
                title="Remove pending file"
              >
                <i className="bi bi-trash" aria-hidden="true" />
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
